import React from 'react';
import { Box, HorizontalScroll } from '@drone-js/core';
import { TopSubcategory } from 'core/type/BootstrapConfig.types';
import ContentContainer from 'component/common/ContentContainer/ContentContainer';
import TopSubcategoryCard from 'component/page/search/City/TopSubcategory/TopSubcategoryCard';
import { withErrorBoundary } from 'component/common/Hoc/ErrorBoundary';

interface Props {
    activitiesCountText: string;
    topSubcategories?: TopSubcategory[];
}

const TopSubcategoryContainerComponent: React.FC<Props> = (props) => {
    if (props.topSubcategories?.length === 0 || props.topSubcategories === undefined) {
        return null;
    }

    return (
        <Box backgroundColor="base.surface" data-testid="top-subcategory-container">
            <ContentContainer display="flex" flexDirection="column" mx="auto" enforceDefaultSpacing={true} maxWidth="100%">
                <HorizontalScroll gap="12" py="8" px="4">
                    {props.topSubcategories.map((item, index) => (
                        // don't remove this div, it is required for HorizontalScroll to display arrow
                        <div key={index}>
                            <TopSubcategoryCard item={item} activitiesCountText={props.activitiesCountText} index={index} />
                        </div>
                    ))}
                </HorizontalScroll>
            </ContentContainer>
        </Box>
    );
};

TopSubcategoryContainerComponent.displayName = 'TopSubcategoryContainerComponent';

const TopSubcategoryContainer = withErrorBoundary(TopSubcategoryContainerComponent);
TopSubcategoryContainer.displayName = 'TopSubcategoryContainer';

export default TopSubcategoryContainer;
